export const cmsActions = {
    GET_ALL_CMS: 'GET_ALL_CMS',
    SET_ALL_CMS: 'SET_ALL_CMS',
    GET_CMS_BY_ID: 'GET_CMS_BY_ID',
    SET_CMS_BY_ID: 'SET_CMS_BY_ID',
    ADD_CMS: 'ADD_CMS',
    SAVE_CMS: 'SAVE_CMS',
    DELETE_CMS: 'DELETE_CMS',
    REFRESH_DELETE_CMS: 'REFRESH_DELETE_CMS',
    GET_CMS_TYPES: 'GET_CMS_TYPES',
    SET_CMS_TYPES: 'SET_CMS_TYPES',
    TEST_CMS_CONNECTION: 'TEST_CMS_CONNECTION',
    REUSLT_TEST_CMS_CONNECTION: 'REUSLT_TEST_CMS_CONNECTION',
    GET_CMS_PROJECTS: 'GET_CMS_PROJECTS',
    SET_CMS_PROJECTS: 'SET_CMS_PROJECTS',
    REFRESH_CMSS: 'REFRESH_CMSS',

    // task manager
    GET_ALL_TASKS_WITH_CMS_ID: 'GET_ALL_TASKS_WITH_CMS_ID',
    GET_ALL_TASKS: 'GET_ALL_TASKS',
    SET_ALL_TASKS: 'SET_ALL_TASKS',
    ADD_TASK: 'ADD_TASK',
    SET_TASK: 'SET_TASK',
    UPDATE_TASK: 'UPDATE_TASK',
    SET_UPDATE_TASK: 'SET_UPDATE_TASK',
    DELETE_TASK: 'DELETE_TASK',

    GET_QUERIES: 'GET_QUERIES',
    SET_QUERIES: 'SET_QUERIES',
    GET_CHECKIN_TASKS_BY_PROJECT_ID: 'GET_CHECKIN_TASKS_BY_PROJECT_ID',
    GET_TASKS_BY_PROJECT_ID: 'GET_TASKS_BY_PROJECT_ID',
    SET_TASKS_BY_PROJECT_ID: 'SET_TASKS_BY_PROJECT_ID',
    GET_TASKS_BY_QUERY_ID: 'GET_TASKS_BY_QUERY_ID',
    SET_TASKS_BY_QUERY_ID: 'SET_TASKS_BY_QUERY_ID',

    // task manager
    GET_ALL_JIRA_CMS_TASKS_QUERYS: 'GET_ALL_JIRA_CMS_TASKS_QUERYS',
    ADD_JIRA_QUERY_TASK: 'ADD_JIRA_QUERY_TASK',
    EDIT_JIRA_QUERY_TASK: 'EDIT_JIRA_QUERY_TASK',
    DELETE_JIRA_QUERY_TASK: 'DELETE_JIRA_QUERY_TASK',
    TEST_JIRA_QUERY_TASK_CONNECTION: 'TEST_JIRA_QUERY_TASK_CONNECTION',
    REUSLT_TEST_JIRA_QUERY_TASK_CONNECTION: 'REUSLT_TEST_JIRA_QUERY_TASK_CONNECTION'
};

const initState = {
    cmss: [],
    cms_types: [],
    test: {},
    cms: {},
    projects: [],
    tasks: [],
    deleteJiraTask: false
};

export const cmsReducer = (state = initState, action: any) => {
    switch (action.type) {
        case cmsActions.SET_QUERIES:
        case cmsActions.SET_ALL_CMS:
        case cmsActions.SET_CMS_BY_ID:
            return Object.assign({}, state, action.payload);

        case cmsActions.SET_CMS_TYPES:
            return Object.assign({}, state, { cms_types: action.payload });

        case cmsActions.GET_CMS_PROJECTS:
            return Object.assign({}, state, { projects: action.payload });

        case cmsActions.REFRESH_DELETE_CMS:
            const cmsExists = state.cmss.filter(item => item.id != action.payload);
            return Object.assign({}, state, {
                cmss: cmsExists || null,
                cms: cmsExists ? cmsExists[0] : null
            });

        case cmsActions.REFRESH_CMSS:
            return { ...state, cmss: [], cms: {} };

        case cmsActions.ADD_CMS:
            return Object.assign({}, state, {
                cmss: [action.payload, ...state.cmss],
                cms: action.payload
            });

        case cmsActions.REUSLT_TEST_CMS_CONNECTION:
        case cmsActions.TEST_JIRA_QUERY_TASK_CONNECTION:
            return Object.assign({}, state, { test: action.payload });

        case cmsActions.SET_ALL_TASKS:
            return Object.assign({}, state, action.payload)

        case cmsActions.SET_TASK:
            return Object.assign({}, state, { tasks: [...state.tasks, action.payload] });

        case cmsActions.EDIT_JIRA_QUERY_TASK:
        case cmsActions.SET_UPDATE_TASK:
            const before = state.tasks.slice(0, action.payload.index);
            const end = state.tasks.slice(action.payload.index + 1, state.tasks.length);
            return Object.assign({}, state, { tasks: [...before, action.payload, ...end] });

        case cmsActions.DELETE_JIRA_QUERY_TASK:
            return Object.assign({}, state, { deleteJiraTask: true });

        case cmsActions.DELETE_TASK:
            const tasksExists = state.tasks.filter(item => item.id != action.payload);
            return Object.assign({}, state, { tasks: tasksExists });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/cmsReducer.ts